import { Radio } from "@mantine/core";
import { RadioSurvey } from "../../../components";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <RadioSurvey
      label="¿Tu organización tiene alguna política o lineamiento interno contra el hostigamiento o acoso sexual laboral?"
      {...form.getInputProps("SP_001_conocePoliticaDePrevencion")}
      orientation="vertical"
    >
      <Radio label="Sí, y la he revisado." value="Sí, y la he revisado." />
      <Radio
        label={`${t("policyKnowledge.notReviewed")}.`}
        value="Sé que existe pero no la he revisado."
      />
      <Radio label={`${t("policyKnowledge.no")}.`} value="No." />
    </RadioSurvey>
  );
};

export default Component;
